module.exports = __webpack_public_path__ + "public/images/logo_po.3e5237b7c7be7df073a5e376065a713f.svg";